import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ErrorDetails, PassengerSmallestResponseDto } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";


export class GetPassengerSmallestComand extends IRequestCommand<PassengerSmallestResponseDto[], ErrorDetails, IPassengerSmallestRequest> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  public override setParameters(parameters: IPassengerSmallestRequest) {
    this.urlSections.push('passengers');
    this.urlSections.push('carrier');
    this.urlSections.push(`${parameters.carrierId}`);
    this.urlSections.push(`forFamily?name=${parameters.name}`);
    this.composeUrl();
  }
}

export interface IPassengerSmallestRequest {
  carrierId: string;
  name: string;
}